import * as React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { LinearProgress } from '@mui/material';

import { useSnackbar } from 'notistack';

import { useAuthorizedFormData } from '../../core/context/AuthorizedFormDataContext';

import { FlightEventFlightDetailsLookup, FlightLookup, SafetyEventReport } from '../../core/api/clients';

import FlightLookupForm from '../../components/FlightLookupForm';
import SafetyEventNewOptions from './SafetyEventNewOptions';
import useCreateNewSafetyEvent from '../../core/api/hooks/safety-event/useCreateNewSafetyEvent';

function SafetyEventFormNew() {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmit, setIsSubmit] = React.useState<boolean>(false);
  const [cssCreate, setCssCreate] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [flightSegments, setFlightSegments] = React.useState<SafetyEventReport[]>([]);

  const authorizedFormData = useAuthorizedFormData();
  const { mutate: createSafetyEvent, status: createSafetyEventStatus } = useCreateNewSafetyEvent();

  const handleCreateSafetyEvent = (flightEventDetailsLookup: FlightEventFlightDetailsLookup) => {
    createSafetyEvent(flightEventDetailsLookup, {
      onSuccess: (safetyEventReports: SafetyEventReport[]) => {
        if (safetyEventReports.length === 1) {
          navigate(
            `${authorizedFormData.metadata?.route}/${safetyEventReports[0].id}/edit`,
            { replace: true },
          );
        } else {
          setFlightSegments(safetyEventReports);
        }
      },
      onError: () => enqueueSnackbar('Flight not found', {
        variant: 'warning',
      }),
    });
  };

  React.useEffect(() => {
    if (searchParams.has('cssLegId')) {
      const cssLegId = searchParams.get('cssLegId');
      if (cssLegId !== null) {
        setCssCreate(true);
        handleCreateSafetyEvent({ cssLegId });
      }
    }
  }, [searchParams]);

  const onSubmit = (flightLookup: FlightLookup) => {
    setIsSubmit(true);
    handleCreateSafetyEvent({ flightLookup });
  };
  const onCancel = () => navigate(authorizedFormData.metadata?.route ?? '');
  const onBlank = () => {
    setIsSubmit(false);
    handleCreateSafetyEvent({});
  };

  if (cssCreate && createSafetyEventStatus === 'pending') {
    return <LinearProgress />;
  }

  return (
    <React.Fragment>
      <FlightLookupForm
        onSubmit={onSubmit}
        onCancel={onCancel}
        onBlank={onBlank}
        color={authorizedFormData.metadata?.color}
        loading={isSubmit && createSafetyEventStatus === 'pending'}
        isDateDefault
      />
      <SafetyEventNewOptions data={flightSegments} />
    </React.Fragment>
  );
}

export default SafetyEventFormNew;
